<div class="profile-page-container w-full min-h-screen py-5 px-3 md:px-5">
  
  <!-- Loading Skeletons State -->
  <ng-container *ngIf="isLoadingPeer; else loadedProfile">
    <div class="container_width mx-auto flex flex-column gap-3 mb-4">
      <p-skeleton width="200px" height="1rem" styleClass="mb-2" />
      <p-skeleton width="400px" height="1.5rem" />
    </div>
    
    <div class="container_width mx-auto grid grid-nogutter gap-4">
      <!-- Left Column Skeleton -->
      <div class="col-12 lg:col-3 flex flex-column gap-4">
        <div class="profile-sidebar-card flex flex-column align-items-center p-4 border-round-2xl border-none">
          <p-skeleton shape="circle" size="6rem" styleClass="mb-3" />
          <p-skeleton width="80%" height="1.5rem" styleClass="mb-2" />
          <p-skeleton width="60%" height="1rem" styleClass="mb-4" />
          <div class="w-full flex flex-column gap-3">
            <p-skeleton width="90%" height="1rem" />
            <p-skeleton width="80%" height="1rem" />
            <p-skeleton width="70%" height="1rem" />
          </div>
        </div>
      </div>
      <!-- Right Column Skeleton -->
      <div class="col-12 lg:col-9 flex flex-column gap-4">
        <div class="admitted-banner-card p-4 border-round-2xl border-none flex align-items-center justify-content-between">
          <div class="flex align-items-center gap-4">
            <p-skeleton shape="square" size="3rem" />
            <div class="flex flex-column gap-2">
              <p-skeleton width="150px" height="1.25rem" />
              <p-skeleton width="250px" height="1rem" />
            </div>
          </div>
          <p-skeleton width="100px" height="2rem" />
        </div>
        <div class="section-card p-4 border-round-2xl border-none">
          <p-skeleton width="30%" height="1.5rem" styleClass="mb-4" />
          <div class="flex flex-column gap-3">
            <p-skeleton width="100%" height="3rem" />
            <p-skeleton width="100%" height="3rem" />
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Loaded Profile Content -->
  <ng-template #loadedProfile>
    <!-- Breadcrumbs moved to main-col -->

    <div class="profile-layout container_width mx-auto">
      <!-- LEFT SIDEBAR COLUMN -->
      <div class="sidebar-col">
        
        <!-- Card 1: Peer Info Card -->
        <div class="profile-sidebar-card flex flex-column p-4 border-round-2xl border-none">
          
          <!-- Avatar and Name Row -->
          <div class="flex flex-row align-items-center gap-3 mb-4">
            <div class="profile-avatar-wrapper relative">
              <img [src]="peer?.imageUrl || (peer?.gender === 1 ? '../../../assets/images/avatar3.jpg' : '../../../assets/images/avatar1.jpg')" alt="" class="profile-avatar-img border-circle" />
            </div>
            <div class="flex flex-column align-items-start gap-2">
              <h3 class="text-white text-xl font-bold m-0 text-left">{{ peerInitialsDot }}</h3>
              <div class="verified-pill">VERIFIED PROFILE</div>
            </div>
          </div>
          
          <div class="profile-meta-list w-full flex flex-column gap-3 mt-2">
            <div class="meta-item flex align-items-center gap-3 text-white text-sm">
              <i class="pi pi-map-marker text-yellow-300 text-lg"></i>
              <span>{{ peer?.city }}, {{ peer?.country }}</span>
            </div>
            <div class="meta-item flex align-items-center gap-3 text-white text-sm">
              <i class="pi pi-calendar text-yellow-300 text-lg"></i>
              <span>Batch of {{ peer?.underGraduateOrExpectedUnderGraduationCompletionYear || peer?.highSchoolCompletionYear }}</span>
            </div>
            <div class="meta-item flex align-items-center gap-3 text-white text-sm" *ngIf="peer?.highSchoolBoard">
              <i class="pi pi-id-card text-yellow-300 text-lg"></i>
              <span>{{ peer?.highSchoolBoard }} Board - {{ peer?.twelvethGrades || peer?.tenthGrades || 'N/A' }}</span>
            </div>
          </div>
        </div>

        <!-- Card 2: Consultation Card -->
        <div class="consultation-sidebar-card flex flex-column border-none">
          <!-- Illustration Wrapper with fade overlay -->
          <div class="consultation-icon-wrapper">
            <img src="../../../assets/images/Group 61.png" alt="" class="consultation-img w-full" />
            <div class="fade-overlay"></div>
          </div>
          
          <!-- Content Block -->
          <div class="consultation-content">
            <!-- Badge -->
            <div class="consultation-badge-pill">
              <span class="badge-dot"></span>
              <span class="badge-text">FREE CONSULTATION</span>
            </div>

            <!-- Title -->
            <h4 class="consultation-title">Build a profile <span class="highlight-navy">just like {{ peerInitialsDot }}</span></h4>
            
            <!-- Description -->
            <p class="consultation-desc">Speak with an admissions expert who has helped <strong class="highlight-navy">2,400+ students</strong> get into top US universities.</p>
            
            <!-- Features Row (inline side-by-side) -->
            <div class="consultation-features-row">
              <div class="feat-pill">
                <i class="pi pi-check feat-icon"></i>
                <span class="feat-text">No obligation</span>
              </div>
              <div class="feat-pill">
                <i class="pi pi-check feat-icon"></i>
                <span class="feat-text">20-min call</span>
              </div>
            </div>

            <!-- Button -->
            <button (click)="openEnquiryModal($event)" class="consultation-btn">Enquire now</button>
          </div>
        </div>

      </div>

      <!-- RIGHT MAIN CONTENT COLUMN -->
      <div class="main-col">
        
        <!-- Breadcrumb and Top Connect Button Bar -->
        <div class="w-full flex flex-row justify-content-between align-items-center mb-4">
          <div class="flex flex-column gap-1">
            <span class="text-xs text-500 font-medium">
              <a [routerLink]="['/portal', 'peer']" class="text-500 hover:text-primary transition-colors no-underline">Peer Profiles</a>
              <span class="mx-2 text-400">&gt;</span>
              <span class="text-700 font-bold">{{ peerInitialsDot }}</span>
            </span>
            <h2 class="text-sm font-normal text-600 mt-1">Review this peer's academic journey and learn from their experience</h2>
          </div>
          <a [routerLink]="['/portal', 'schedule-peer-call', peer?.applicationUserId]" class="connect-btn-top p-button border-round-xl no-underline flex align-items-center justify-content-center gap-2 px-4 py-2 font-bold text-sm bg-primary text-white border-none cursor-pointer">
            <i class="pi pi-comments"></i> Connect
          </a>
        </div>

        <!-- Section 1: Admitted To University Banner -->
        <div class="admitted-banner-card flex flex-column md:flex-row align-items-center justify-content-between p-4 border-round-2xl border-none" *ngIf="peer?.underGraduateCollageName || peer?.graduateCollageName">
          <div class="flex align-items-center gap-4 mb-3 md:mb-0">
            <div class="university-logo-container p-2 bg-white border-round-xl shadow-1 flex align-items-center justify-content-center" style="width: 54px; height: 54px;">
              <i class="pi pi-building text-3xl text-indigo-700"></i>
            </div>
            <div class="flex flex-column">
              <span class="text-xs font-bold text-500 uppercase tracking-wide">ADMITTED TO</span>
              <h3 class="text-lg font-bold text-900 mt-1">{{ peer?.underGraduateCollageName || peer?.graduateCollageName }}</h3>
              <p class="text-xs text-600 mt-1 font-semibold">{{ peer?.underGraduateMajorOrDegree || peer?.graduateMajorOrDegree }} - Class of {{ peer?.underGraduateOrExpectedUnderGraduationCompletionYear || peer?.graduateOrExpectedGraduationCompletionYear }}</p>
            </div>
          </div>
          
          <!-- Score Highlights -->
          <div class="flex gap-4 align-items-center score-highlights">
            <div class="flex flex-column align-items-center" *ngIf="peer?.satOverallScore">
              <span class="stat-number">{{ peer?.satOverallScore }}</span>
              <span class="stat-label">SAT SCORE</span>
            </div>
            <span class="stat-divider" *ngIf="peer?.satOverallScore && peer?.twelvethGrades"></span>
            
            <div class="flex flex-column align-items-center" *ngIf="peer?.twelvethGrades">
              <span class="stat-number">{{ peer?.twelvethGrades }}{{ (peer?.twelvethGrades && !peer?.twelvethGrades?.includes('%')) ? '%' : '' }}</span>
              <span class="stat-label">XII GRADE</span>
            </div>
            <span class="stat-divider" *ngIf="peer?.twelvethGrades"></span>
            
            <div class="flex flex-column align-items-center">
              <div class="destination-flag-wrapper" *ngIf="getCountryCode(peer?.underGraduateCollageCountry || peer?.graduateCollageCountry)">
                <img [src]="'https://flagsapi.com/' + getCountryCode(peer?.underGraduateCollageCountry || peer?.graduateCollageCountry) + '/flat/64.png'" [alt]="peer?.underGraduateCollageCountry || peer?.graduateCollageCountry" class="destination-flag" />
              </div>
              <span class="stat-label">DESTINATION</span>
            </div>
          </div>
        </div>

        <!-- Section 2: Dreaming of NYU or similar banner -->
        <div class="dreaming-banner-card flex flex-column md:flex-row align-items-center justify-content-between border-none">
          <div class="flex align-items-center gap-4 mb-3 md:mb-0">
            <img src="../../../assets/images/Group 43.png" alt="Group 43" class="dreaming-banner-img" />
            <div class="flex flex-column gap-2 text-container-block">
              <h4 class="banner-title-text">Dreaming of <span class="highlight-lime">{{ peer?.underGraduateCollageName || peer?.graduateCollageName || 'Top Universities' }}</span> or similar?</h4>
              <p class="banner-desc-text">Fill your application form to know where you stand</p>
            </div>
          </div>
          <a [routerLink]="['/portal', 'mentor-me']" class="fill-form-btn no-underline text-center cursor-pointer">Fill Application form</a>
        </div>

        <!-- Section 3: Test Scores -->
        <div class="section-card p-4 border-round-2xl border-none">
          <div class="flex align-items-center justify-content-between mb-4 border-bottom-1 pb-3 border-100">
            <div class="flex align-items-center gap-2">
              <div class="section-icon-badge bg-indigo-50 text-indigo-700 flex align-items-center justify-content-center">
                <i class="pi pi-user"></i>
              </div>
              <h3 class="text-base font-bold text-900">Test Scores</h3>
            </div>
            <button class="score-info-btn">Score Details</button>
          </div>

          <div class="flex flex-column gap-4">
            <!-- SAT scores -->
            <div class="score-row flex flex-column gap-2" *ngIf="peer?.satOverallScore">
              <span class="text-xs font-bold text-500 uppercase tracking-wider">SAT</span>
              <div class="grid grid-nogutter gap-3">
                <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">OVERALL</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.satOverallScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">ENGLISH</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.satEnglishScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">MATH</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.satMathScore || 'N/A' }}</span>
                </div>
              </div>
            </div>

            <!-- ACT scores -->
            <div class="score-row flex flex-column gap-2" *ngIf="peer?.actOverallScore">
              <span class="text-xs font-bold text-500 uppercase tracking-wider">ACT</span>
              <div class="grid grid-nogutter gap-3">
                <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">OVERALL</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.actOverallScore || 'N/A' }}</span>
                </div>
                <!-- <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span class="text-500 mb-1 font-bold" style="font-size: 10px;">ENGLISH</span>
                  <span class="text-base font-bold text-900">{{ peer?.actEnglishScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl">
                  <span class="text-500 mb-1 font-bold" style="font-size: 10px;">MATH</span>
                  <span class="text-base font-bold text-900">{{ peer?.actMathScore || 'N/A' }}</span>
                </div> -->
              </div>
            </div>

            <!-- Other scores -->
            <div class="score-row flex flex-column gap-2">
              <span class="text-xs font-bold text-500 uppercase tracking-wider">OTHER</span>
              <div class="grid grid-nogutter gap-3 flex-wrap">
                <div class="col flex flex-column p-3 score-box border-round-xl" style="min-width: 80px;">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">GRE</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.greScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl" style="min-width: 80px;">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">GMAT</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.gmatScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl" style="min-width: 80px;">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">IELTS</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.ieltsScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl" style="min-width: 80px;">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">TOEFL</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.toeflScore || 'N/A' }}</span>
                </div>
                <div class="col flex flex-column p-3 score-box border-round-xl" style="min-width: 80px;">
                  <span style="color:#8A9060;font-size:10px;font-weight:700;">AP</span>
                  <span style="color:#000066;font-size:1rem;font-weight:700;">{{ peer?.apScore || 'N/A' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Section 4: Personal Information -->
        <div class="section-card p-4 border-round-2xl border-none">
          <div class="personal-info-header">
            <div class="personal-info-title">
              <div class="section-icon-badge bg-indigo-50 text-indigo-700 flex align-items-center justify-content-center">
                <i class="pi pi-user"></i>
              </div>
              <h3 class="personal-info-heading">Personal Information</h3>
            </div>
            <button class="personal-info-btn">Basic Details</button>
          </div>

          <div class="personal-info-divider"></div>

          <div class="personal-info-grid">
            <!-- Row 1 -->
            <div class="info-field">
              <span class="info-label">FIRST NAME</span>
              <span class="info-value">{{ peer?.firstName ? (peer!.firstName | slice:0:1 | uppercase) + '.' : 'N/A' }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">LAST NAME</span>
              <span class="info-value">{{ peer?.lastName ? (peer!.lastName | slice:0:1 | uppercase) + '.' : 'N/A' }}</span>
            </div>
            <div class="info-field">
              <span class="info-label">CITY</span>
              <span class="info-value info-value--accent">{{ peer?.city || 'N/A' }}</span>
            </div>

            <!-- Row 2 -->
            <div class="info-field">
              <span class="info-label">COUNTRY</span>
              <span class="info-value info-value--flag">
                {{ peer?.country || 'N/A' }}
                <img *ngIf="getCountryCode(peer?.country)"
                     [src]="'https://flagsapi.com/' + getCountryCode(peer?.country) + '/flat/24.png'"
                     alt="" style="width:18px;border-radius:2px;margin-left:4px;" />
              </span>
            </div>
            <!-- <div class="info-field">
              <span class="info-label">BATCH YEAR</span>
              <span class="info-value">{{ peer?.highSchoolCompletionYear || 'N/A' }}</span>
            </div> -->
            <div class="info-field">
              <span class="info-label">DESTINATION</span>
              <span class="info-value info-value--flag">
                {{ peer?.underGraduateCollageCountry || peer?.graduateCollageCountry || 'United States' }}
                <img *ngIf="getCountryCode(peer?.underGraduateCollageCountry || peer?.graduateCollageCountry)"
                     [src]="'https://flagsapi.com/' + getCountryCode(peer?.underGraduateCollageCountry || peer?.graduateCollageCountry || 'United States') + '/flat/24.png'"
                     alt="" style="width:18px;border-radius:2px;margin-left:4px;" />
              </span>
            </div>
          </div>
        </div>

        <!-- Section 5: Academic Journey -->
        <div class="section-card p-4 border-round-2xl border-none">
          <div class="flex align-items-center justify-content-between mb-4 border-bottom-1 pb-3 border-100">
            <div class="flex align-items-center gap-2">
              <div class="section-icon-badge bg-orange-50 text-orange-700 flex align-items-center justify-content-center">
                <i class="pi pi-graduation-cap"></i>
              </div>
              <h3 class="text-base font-bold text-900">Academic Journey</h3>
            </div>
            <button class="Educational-info-btn">Education Timeline</button>
          </div>

          <!-- Timeline -->
          <div class="academic-timeline flex flex-column gap-5 pl-4 position-relative mt-2">
            
            <!-- High school Timeline Item -->
            <div class="timeline-item flex gap-4 position-relative">
              <div class="timeline-dot-wrapper">
                <span class="timeline-dot"></span>
              </div>
              <div class="flex flex-column gap-2 flex-1">
                <div class="flex align-items-center gap-2">
                  <span class="font-bold text-500" style="font-size: 11px;">{{ peer?.highSchoolCompletionYear }} - HIGH SCHOOL</span>
                </div>
                <h4 class="text-base font-bold text-900">{{ peer?.highSchoolName }}</h4>
                <p class="text-xs text-500 font-semibold" style="color: #6B7280;">{{ peer?.highSchoolBoard }}</p>
                
                <div class="grid grid-nogutter gap-3 mt-2">
                  <!-- <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">YEAR GRADUATED</span>
                    <span class="text-xs font-bold text-900">{{ peer?.highSchoolCompletionYear || 'N/A' }}</span>
                  </div> -->
                  <div class="col flex flex-column gap-1" *ngIf="peer?.tenthGrades">
                    <span class="text-500 font-bold" style="font-size: 10px;">CLASS X GRADES</span>
                    <span class="text-xs font-bold text-900">{{ peer?.tenthGrades }}</span>
                  </div>
                  <div class="col flex flex-column gap-1" *ngIf="peer?.twelvethGrades">
                    <span class="text-500 font-bold" style="font-size: 10px;">CLASS XII GRADES</span>
                    <span class="text-xs font-bold text-900">{{ peer?.twelvethGrades }}</span>
                  </div>
                  <!-- <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">COURSEWORK</span>
                    <span class="text-xs font-bold text-900">{{ peer?.courseWork || '--' }}</span>
                  </div> -->
                </div>
              </div>
            </div>

            <!-- Undergraduate Timeline Item -->
            <div class="timeline-item flex gap-4 position-relative" *ngIf="peer?.underGraduateCollageName">
              <div class="timeline-dot-wrapper">
                <span class="timeline-dot active-dot"></span>
              </div>
              <div class="flex flex-column gap-2 flex-1">
                <div class="flex align-items-center gap-2">
                  <span class="font-bold text-primary" style="font-size: 11px;">{{ peer?.underGraduateOrExpectedUnderGraduationCompletionYear }} - UNDERGRADUATE</span>
                  <span class="timeline-status-badge active-badge">Current</span>
                </div>
                <h4 class="text-base font-bold text-900">{{ peer?.underGraduateCollageName }}</h4>
                <p class="text-xs text-500 font-semibold" style="color: #6B7280;">{{ peer?.underGraduateCollageCity }}, {{ peer?.underGraduateCollageCountry }}</p>
                
                <div class="grid grid-nogutter gap-3 mt-2">
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">MAJOR / DEGREE</span>
                    <span class="text-xs font-bold text-primary">{{ peer?.underGraduateMajorOrDegree }}</span>
                  </div>
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">EXP. GRADUATION</span>
                    <span class="text-xs font-bold text-900">{{ peer?.underGraduateOrExpectedUnderGraduationCompletionYear }}</span>
                  </div>
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">EXPECTED GRADE</span>
                    <span class="text-xs font-bold text-900">{{ peer?.underGraduateExpectedGrades || 'Not mentioned' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Graduate Timeline Item -->
            <div class="timeline-item flex gap-4 position-relative" *ngIf="peer?.graduateCollageName">
              <div class="timeline-dot-wrapper">
                <span class="timeline-dot upcoming-dot"></span>
              </div>
              <div class="flex flex-column gap-2 flex-1">
                <div class="flex align-items-center gap-2">
                  <span class="font-bold text-yellow-600" style="font-size: 11px;">GRADUATE</span>
                  <span class="timeline-status-badge upcoming-badge">Upcoming</span>
                </div>
                <h4 class="text-base font-bold text-900">{{ peer?.graduateCollageName }}</h4>
                <p class="text-xs text-500 font-semibold" style="color: #6B7280;">{{ peer?.graduateCollageCity }}, {{ peer?.graduateCollageCountry }}</p>
                
                <div class="grid grid-nogutter gap-3 mt-2">
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">MAJOR / DEGREE</span>
                    <span class="text-xs font-bold text-900">{{ peer?.graduateMajorOrDegree }}</span>
                  </div>
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">EXP. GRADUATION</span>
                    <span class="text-xs font-bold text-900">{{ peer?.graduateOrExpectedGraduationCompletionYear }}</span>
                  </div>
                  <div class="col flex flex-column gap-1">
                    <span class="text-500 font-bold" style="font-size: 10px;">EXPECTED GRADE</span>
                    <span class="text-xs font-bold text-900">{{ peer?.graduateExpectedGrades || 'Not mentioned' }}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Section 6: Extracurricular Activities -->
        <div class="section-card p-4 border-round-2xl border-none" *ngIf="extracurricularList.length > 0">
          <div class="flex align-items-center justify-content-between mb-4 border-bottom-1 pb-3 border-100">
            <div class="flex align-items-center gap-2">
              <div class="section-icon-badge bg-yellow-50 text-yellow-700 flex align-items-center justify-content-center">
                <i class="pi pi-star"></i>
              </div>
              <h3 class="text-base font-bold text-900">Extracurricular Activities</h3>
            </div>
            <button class="Extracurricular-info-btn ">Leadership & Impact</button>
          </div>

          <div class="flex flex-column gap-3">
            <div class="extracurricular-box flex align-items-center p-3 border-round-xl" *ngFor="let item of extracurricularList">
              <span class="bullet-gold mr-3"></span>
              <p class="text-sm text-800 font-semibold flex-1 leading-normal">{{ item }}</p>
            </div>
          </div>
        </div>

        <!-- Section 7: Short Bio -->
        <div class="section-card p-4 border-round-2xl border-none" *ngIf="peer?.shortBio">
          <div class="flex align-items-center justify-content-between mb-4 border-bottom-1 pb-3 border-100">
            <div class="flex align-items-center gap-2">
              <div class="section-icon-badge bg-blue-50 text-blue-700 flex align-items-center justify-content-center">
                <i class="pi pi-info-circle"></i>
              </div>
              <h3 class="text-base font-bold text-900">Short Bio</h3>
            </div>
          </div>

          <div class="bio-box p-3 border-round-xl">
            <p class="text-sm text-700" style="line-height: 1.6;">{{ peer?.shortBio }}</p>
          </div>
        </div>

        <!-- Section 8: Ready to write your own success story -->
        <div class="success-banner-card">
          <!-- Pill badge -->
          <div class="success-badge">
            <i class="pi pi-star"></i>
            <span>YOUR TURN NEXT</span>
          </div>

          <!-- Heading -->
          <h2 class="success-heading">Ready to write <strong>your own</strong> success story?</h2>

          <!-- Subtext -->
          <p class="success-subtext">{{ peerInitialsDot }} started exactly where you are. Our admissions team will show you the roadmap to your dream university — no guesswork, just a clear plan.</p>

          <!-- CTA Button -->
          <button (click)="openEnquiryModal($event)" class="success-enquire-btn">Enquire Now — It's Free</button>

          <!-- Stats row -->
          <div class="success-stats">
            <span><i class="pi pi-check"></i> 2,400+ admissions</span>
            <span class="success-dot">·</span>
            <span><i class="pi pi-check"></i> Reply in under 2 hrs</span>
            <span class="success-dot">·</span>
            <span><i class="pi pi-check"></i> No obligation</span>
          </div>
        </div>

        <!-- Section 9: Browse Similar Profiles -->
        <div class="similar-profiles-section flex flex-column gap-3 mt-2" *ngIf="similarPeers.length > 0">
          <div class="flex align-items-center justify-content-between mb-2">
            <h3 class="text-base font-bold text-navy-dark m-0" style="color: #0A1172;">Browse similar profiles</h3>
            <a [routerLink]="['/portal', 'peer']" class="text-sm font-bold transition-colors no-underline" style="color: #0A1172;">See all &rarr;</a>
          </div>
          
          <div class="grid grid-nogutter gap-4">
            <div class="col-12 sm:col flex flex-column similar-peer-card p-4 border-none" *ngFor="let sim of similarPeers">
              
              <!-- Card Header -->
              <div class="flex align-items-center gap-3 mb-3">
                <div class="similar-avatar-wrapper relative" style="width: 60px; height: 60px;">
                  <img [src]="sim.imageUrl || (sim.gender === 1 ? '../../../assets/images/avatar3.jpg' : '../../../assets/images/avatar1.jpg')" alt="" class="similar-avatar-img border-circle w-full h-full" style="object-fit: cover;" />
                  <span class="verified-badge-sm flex align-items-center justify-content-center">
                    <i class="pi pi-check"></i>
                  </span>
                </div>
                <div class="flex flex-column gap-1 flex-1">
                  <h4 class="text-base font-bold text-white m-0 text-left">{{ getInitialsDot(sim.firstName, sim.lastName) }}</h4>
                  <span class="text-xs text-left font-medium text-ellipsis" style="color: #A0A5CA; max-width: 150px;">{{ sim.underGraduateCollageName || sim.graduateCollageName }}</span>
                </div>
              </div>

              <div class="verified-tag-sm mb-3">VERIFIED PROFILE</div>

              <!-- List stats -->
              <div class="similar-stats-list flex flex-column gap-2">
                <span class="text-xs flex align-items-center gap-2" style="color: #D1D5DB;">
                  <i class="pi pi-map-marker" style="color: #E2E97A;"></i> {{ sim.city }}, {{ sim.country }}
                </span>
                <span class="text-xs flex align-items-center gap-2" style="color: #D1D5DB;">
                  <i class="pi pi-file" style="color: #E2E97A;"></i> Batch of {{ sim.underGraduateOrExpectedUnderGraduationCompletionYear || sim.highSchoolCompletionYear }}
                </span>
                <span class="text-xs flex align-items-center gap-2" style="color: #D1D5DB;" *ngIf="sim.highSchoolBoard">
                  <i class="pi pi-graduation-cap" style="color: #E2E97A;"></i> {{ sim.highSchoolBoard }} Board - {{ sim.twelvethGrades || 'N/A' }}
                </span>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </ng-template>

  <!-- Custom Enquiry Popup Modal -->
  <div class="custom-modal-overlay flex align-items-center justify-content-center" *ngIf="showEnquiryModal" (click)="closeEnquiryModal()">
    <div class="custom-modal-content p-5 border-round-3xl relative" (click)="$event.stopPropagation()">
      
      <!-- Close Button -->
      <button class="close-btn absolute cursor-pointer bg-transparent border-none text-white flex align-items-center justify-content-center" (click)="closeEnquiryModal()">
        <i class="pi pi-times text-xl"></i>
      </button>
      
      <!-- Paper Plane Floating Illustration -->
      <div class="paper-plane-wrapper absolute">
        <img src="../../../assets/images/contact_up_pop_up_plane.png" class="paper-plane-img" alt="Paper Plane">
      </div>

      <!-- Header Title -->
      <h2 class="text-3xl font-bold leading-tight mb-2 tracking-tight">
        <span class="text-yellow-300 block mb-1">Been overthinking?</span>
        <span class="text-white block">Drop it here.</span>
      </h2>
      
      <!-- Description -->
      <p class="text-white-alpha-90 text-sm leading-relaxed mb-4 max-w-28rem mt-3">
        You don't have to sort everything alone, neither do you have to have everything figured out. Just share where you're at, and we'll help you take the right next step.
      </p>
      
      <!-- Query Input Box -->
      <div class="query-input-container p-3 border-round-2xl relative mt-4">
        <textarea class="query-textarea w-full border-none outline-none text-base resize-none bg-transparent" placeholder="Type your query here" [(ngModel)]="enquiryQuery"></textarea>
        <button class="send-btn absolute cursor-pointer border-none text-white px-4 py-2 font-bold text-sm border-round-lg flex align-items-center justify-content-center" [disabled]="isSendingEnquiry" (click)="sendEnquiry()">
          <span *ngIf="!isSendingEnquiry">Send</span>
          <i class="pi pi-spin pi-spinner" *ngIf="isSendingEnquiry"></i>
        </button>
      </div>

    </div>
  </div>
</div>
